import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import {Countries} from '../../../../assets/countries/countries';

export class WhiteLabelCountryStatisticsModel extends Model {
  @Expose()
  @Transform(({ value }) => value && value.toLowerCase())
  country: string;
  @Expose()
  @Transform(({ obj }) => obj?.country && obj?.country.toUpperCase())
  countryCode: string;
  @Expose() percentage: number;
  @Expose()
  @Transform(({ obj }) => {
    if (obj && obj?.country) {
      return Countries.find((country) => country.code.toLowerCase() == obj?.country.toLowerCase())?.name;
    } else {
      return null;
    }
  })
  fullName: string | null;
}
